import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnHeader } from 'src/app/models/column-header';
import { SrcPath } from 'src/app/constants/srcPath';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isData, iconListOptions, iconStyleOptions, setTableName, popupWidthClassOptions } from 'src/app/utils/utils';
import { CommonService } from 'src/app/services/common-service/common.service';
import { RoutePath } from 'src/app/constants/routerPath';
import { Labels } from 'src/app/constants/labels';
import { KEYS } from 'src/app/constants/keys';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu-create-page',
  templateUrl: './menu-create-page.component.html',
  styleUrls: ['./menu-create-page.component.scss'],
  imports: [CommonModule, NgSelectComponent, FormsModule, ReactiveFormsModule, SharedModule]
})
export class MenuCreatePageComponent implements OnInit {
  public appPageList: any = [];
  createPageForm: FormGroup | any;
  headerData: ColumnHeader | any;
  srcPath = SrcPath;
  inputMode: any;
  menuId: any;
  pageId: any;
  pageName: any;
  pageDescription: any;
  pageIcon: any;
  pageBgColor: any;
  iconStyle: any;
  isLinkPage: boolean = false;
  linkPageId: any;
  isShowStaticData: boolean = false;
  staticDataPageId: any;
  labelName = Labels.labels;
  labelPage = Labels.page;
  labelbuttons = Labels.buttons;
  labelIconStyle = Labels.iconStyle;
  routePath = RoutePath;
  iconListOption = iconListOptions;
  iconStyleOption = iconStyleOptions;
  labelMessages = Labels.messages;
  pageTitle: any;
  isSuperaDmin: boolean = false;
  dbPath: any;
  popupWidthClassOption = popupWidthClassOptions;
  popupWidthClass: any;
  messageLabel = Labels.messages;

  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.initColumnHeader();
    this.initPageForm();
    this.loadPageList();
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  initColumnHeader() {
    this.route.queryParams.subscribe((params: any) => {
      this.inputMode = params['inputMode'];
      this.menuId = params['menuId'];
      this.pageId = this.inputMode == KEYS.actionType.add ? '' : params['pageId'];
      this.pageName = this.inputMode == KEYS.actionType.add ? '' : params['pageName'];
      this.pageDescription = this.inputMode == KEYS.actionType.add ? '' : params['pageDescription'];
      this.pageIcon = this.inputMode == KEYS.actionType.add ? this.labelName.default_icon : params['pageIcon'];
      this.pageBgColor = this.inputMode == KEYS.actionType.add ? '' : params['pageBgColor'];
      this.iconStyle = this.inputMode == KEYS.actionType.add ? '' : params['iconStyle'];
      this.isLinkPage = params['linkPageId'] > KEYS.menuParent.defaultID ? true : false;
      this.linkPageId = this.inputMode == KEYS.actionType.add ? '' : params['linkPageId'];
      this.isShowStaticData = params['staticDataPageId'] > KEYS.menuParent.defaultID ? true : false;
      this.staticDataPageId = this.inputMode == KEYS.actionType.add ? '' : params['staticDataPageId'];
      this.pageTitle = this.inputMode == KEYS.actionType.add ? this.labelPage.create_page : this.labelPage.edit_page;
      this.popupWidthClass = this.inputMode == null ? '' : params['popupWidthClass'];
    });
    this.headerData = {
      title: this.pageTitle,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.labelbuttons.back_menu,
            icon: SrcPath.previousIcon,
            class: this.labelIconStyle.eleven
          },
          {
            title: this.labelbuttons.save_page,
            icon: SrcPath.saveIcon,
            class: this.labelIconStyle.nine
          }
        ]
      }
    };
  }
  initPageForm() {
    let lnkId = this.isLinkPage == true ? parseInt(this.linkPageId) : this.linkPageId;
    let stpId = this.isShowStaticData == true ? parseInt(this.staticDataPageId) : this.staticDataPageId;
    this.createPageForm = this.formBuilder.group({
      parentMenuId: [this.menuId],
      pageId: [this.pageId],
      pageName: [this.pageName, Validators.required],
      pageDescription: [this.pageDescription],
      pageIcon: [this.pageIcon, Validators.required],
      iconStyle: [this.iconStyle, Validators.required],
      pageBgColor: [this.pageBgColor],
      isLinkPage: [this.isLinkPage, Validators.required],
      linkPageId: [lnkId],
      isShowStaticData: [this.isShowStaticData, Validators.required],
      staticDataPageId: [stpId],
      popupWidthClass: this.popupWidthClass
    });
  }
  onSubmit() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    if (this.inputMode == KEYS.actionType.add) {
      let tblName = setTableName(this.createPageForm.value.pageName);
      this.commonService.saveTable(dbFullPath, tblName).subscribe((data: any) => {
        this.commonService.addNewPageWithMenu(
          dbFullPath,
          this.createPageForm.value.pageName,
          this.createPageForm.value.pageDescription,
          this.commonService.getUserCredentials(KEYS.credential_customer_id),
          tblName,
          this.createPageForm.value.pageIcon,
          this.createPageForm.value.pageBgColor,
          this.createPageForm.value.iconStyle,
          this.createPageForm.value.parentMenuId,
          this.createPageForm.value.linkPageId,
          this.createPageForm.value.staticDataPageId,
          this.createPageForm.value.popupWidthClass
        ).subscribe((data: any) => {
          //this.toastr.success(this.labelMessages.save_success_msg.message);
           this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
          this.router.navigate([this.routePath.dashboard]);
        });
      });

    } else {
      this.commonService.updatePage(
        dbFullPath,
        this.createPageForm.value.pageId,
        this.createPageForm.value.pageName,
        this.createPageForm.value.pageDescription,
        this.createPageForm.value.pageIcon,
        this.createPageForm.value.pageBgColor,
        this.createPageForm.value.iconStyle,
        this.commonService.getUserCredentials(KEYS.credential_customer_id),
        this.createPageForm.value.linkPageId,
        this.createPageForm.value.staticDataPageId,
        this.createPageForm.value.popupWidthClass, 0).subscribe((data: any) => {
         // this.toastr.success(this.labelMessages.update_success_msg.message);
         this.commonService.showModalValidate(this.labelMessages.update_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.update_success_msg.message);
          this.router.navigate([this.routePath.dashboard]);
        });
    }
  }
  loadPageList() {
    this.appPageList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageList(dbFullPath).subscribe((data: any) => {
      if (isData(data)) {
        data['table'].forEach((element: any) => {
          this.appPageList.push({
            'pageId': element.gstibo_page_id,
            'pageName': element.gstibo_page_name
          });
        });
      }
    });
  }

}
